export default {
  radar: {
    searchPlaceholder: "Buscar evento, producto, principio activo, laboratorio…",
    // Vista por grupo de hitos (R-30, §90)
    viewByBlock: "Por bloque del catálogo",
    scopeMarket: "Todo el mercado",
    scopeUniverse: "Tu universo",
    scopeHint: "Tu universo: solo los eventos de tus productos y de tu competencia",
    blockEmpty: "Sin eventos este mes",
    hitosInBlock: "{n} hitos con eventos",
    hitosInBlockOne: "1 hito con eventos",
    sourceSince: "Vigilada desde el {date}",
    moreInHito: "y {n} más: búscalos o exporta el mes",
    confirmedBy: "confirmado por {n} fuentes",
    expandAll: "Desplegar todo",
    collapseAll: "Plegar todo",
    viewByGroup: "Por grupo de hitos",
    viewBySource: "Por fuente",
    groupHitos: "{n} hitos distintos este mes",
    groupHitosOne: "1 hito este mes",
    colHito: "Hito",
    noGroupEvents: "Ningún evento este mes con ese filtro",
    allSources: "Todas las fuentes",
    exportExcel: "Exportar Excel",
    exporting: "Exportando…",
    searching: "Buscando…",
    resultsCount: "{n} eventos encontrados",
    noResults: "Ningún evento coincide con la búsqueda",
    pageOf: "Página {page} de {total}",
    colDate: "Fecha",
    colSource: "Fuente",
    colProduct: "Evento / Producto",
    colActiveIngredient: "P. Activo",
    colLaboratory: "Laboratorio",
    title: "Radar Regulatorio",
    subtitle: "Eventos de todas las fuentes de HelixScan, por bloque del catálogo de hitos",
    loading: "Cargando radar regulatorio…",
    loadErrorMsg: "No se pudo cargar la información. Comprueba tu conexión.",
    retry: "Reintentar",
    eventsCount: "{n} eventos",
    monthsShort: "Ene,Feb,Mar,Abr,May,Jun,Jul,Ago,Sep,Oct,Nov,Dic",
    // Etiquetas de portfolio / competencia
    portfolio: "Portfolio",
    competitor: "Competidor",
    portfolioCount: "{n} Portfolio",
    competitorCount: "{n} Competidor",
    // KPIs
    kpiPreciosLabel: "Bajadas de precio",
    kpiPreciosDesc: "SPRAH + CIPM",
    kpiFinanciacionLabel: "Nuevas financiaciones",
    kpiFinanciacionDesc: "SPRAH SNS",
    kpiAutorizacionesLabel: "Autorizaciones",
    kpiAutorizacionesDesc: "EMA · CMH · IPT",
    kpiRegulatorioLabel: "BOE + Nomenclátor",
    kpiRegulatorioDesc: "Publicaciones BOE",
    kpiPortfolio: "{n} portfolio",
    kpiComp: "{n} comp.",
    // Fila de evento
    view: "Ver",
    previous: "ant.",
    paLabel: "P.A.",
    labLabel: "Lab.",
    // Lane (la API trae label/descr en ES; se traducen por clave)
    laneLabel: {
      precios: "Cambios de Precio",
      financiacion: "Nuevas Financiaciones",
      autorizaciones: "Autorizaciones & Pipeline",
      regulatorio: "BOE & Regulatorio",
    },
    laneDesc: {
      precios: "Bajadas voluntarias SPRAH y acuerdos de precio CIPM",
      financiacion: "Medicamentos que obtienen financiación pública SNS",
      autorizaciones: "Autorizaciones EMA, reuniones CMH e informes de posicionamiento IPT",
      regulatorio: "Publicaciones BOE con impacto farmacéutico y cambios en el Nomenclátor",
    },
    noEvents: "Sin eventos este mes",
    nomenclatorUpdated: "medicamentos actualizados en el Nomenclátor de Prescripción (AEMPS)",
    showMore: "Ver {n} más",
    // Pie
    sourcesLabel: "Fuentes:",
    footerNote: "Los datos se actualizan automáticamente tras cada lectura programada de cada fuente.",
  },
};
